module.exports = __webpack_public_path__ + "static/media/sloclapslogo.f8d69e85.png";